import React, { Component } from "react";
import {
  Card,
  Col,
  Form,
  Row,
  Spin,
  Button,
  Input,
  DatePicker,
  Upload,
  Radio,
} from "antd";
import * as Swal from "sweetalert2";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import ReactQuill from "react-quill";
import QuillStyle from "../../commons/EditorQuill/QuillStyle";
import { httpClient } from "../../utils/axios";
// import ImgCrop from "antd-img-crop";
import moment from "moment";
import "moment/locale/th";
import { refreshToken } from "../../utils/refreshToken";
import { Layout } from "../../containers";
import { eventsApi } from "../../../apis";

const { RangePicker } = DatePicker;
const { Search } = Input;

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener("load", (e) => {
    const img = new Image();
    img.src = e.target.result;
    img.onload = () => {
      callback(reader.result);
    };
  });
  Swal.close();
  reader.readAsDataURL(img);
}

function beforeUpload(file) {
  Swal.fire({
    title: "ระบบกำลังทำงาน",
    allowEscapeKey: false,
    allowOutsideClick: false,
    showConfirmButton: false,
    onOpen: () => {
      Swal.showLoading();
    },
  });
  const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
  if (!isJpgOrPng) {
    Swal.close();
    Swal.fire({
      icon: "error",
      text: `You can only upload JPG/PNG file!`,
      timer: 1500,
      showConfirmButton: false,
    });
  }
  const isLt10M = file.size / 1024 / 1024 < 1;
  if (!isLt10M) {
    Swal.close();
    Swal.fire({
      icon: "error",
      text: `Image must smaller than 1MB!`,
      timer: 1500,
      showConfirmButton: false,
    });
  }
  return isJpgOrPng && isLt10M;
}

class CampaignEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageUrl: null,
      nameCode: "",
      startDate: "",
      endDate: "",
      loading: false,
      radioStatusValueEdit: 0,
      check_token: false,
    };
    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.reactQuillRef = null;
  }

  componentDidMount = () => {
    this.checkToken();
  };

  componentWillUnmount() {
    clearInterval(this.timeout);
  }

  handleChangeInput(changeObject) {
    this.setState(changeObject);
  }

  checkToken = async () => {
    const now = moment().unix();
    if (now >= localStorage.getItem("exp_access_token")) {
      const check = await refreshToken();
      if (check) {
        this.timeout = setTimeout(() => {
          this.fetchData();
        }, 1);
      } else {
        window.location.href = "/";
      }
    } else {
      this.fetchData();
    }
  };

  fetchData = async () => {
    this.setState({
      check_token: true,
    });
    const id = this.props.match.params.campaignId;
    this.setState({ loading: true });
    const setData = (doc) => {
      const start = doc.events_details && doc.events_details.start_date;
      const end = doc.events_details && doc.events_details.end_date;

      const startDate = moment(start, "DD/MM/YYYY").format("YYYY-MM-DD");
      const endDate = moment(end, "DD/MM/YYYY").format("YYYY-MM-DD");
      this.setState({
        topicInputActivityEdit: doc.name,
        textAreaInputActivityEdit:
          doc.events_details && doc.events_details.detail,
        nameCodeEdit: doc.events_details && doc.events_details.code,
        quantityExchangeEdit: `${
          doc.events_details && doc.events_details.amount
        }`,
        quantityAddPointsEdit: `${doc.points}`,
        imageUrl: doc.image_m,
        imageFile: null,
        startDate,
        endDate,
        loading: false,
        radioStatusValueEdit: doc.status,
      });
    };

    eventsApi
      .eventOnlineActivittyById(id)
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: `${error.response.data.message}`,
          timer: 1500,
          showConfirmButton: false,
        }).then(() => {
          this.setState({
            loading: false,
          });
        });
      });
  };

  handleCancel = () => {
    this.props.history.push("/campaign");
  };

  // การเปลื่ยนแปลงของ Photo
  handleChangePhoto = async (info) => {
    if (info.file.status === "uploading") {
      return;
    }
    if (info.file.status === "done") {
      await getBase64(info.file.originFileObj, (imageUrl) => {
        this.setState({
          imageUrl,
          imageFile: info.file.originFileObj,
          loading: false,
        });
      });
    }
  };

  onChange = (value) => {
    this.setState({
      startDate: value[0],
      endDate: value[1],
    });
  };

  onFinish = (values) => {
    const id = this.props.match.params.campaignId;
    const that = this.props;
    const formData = new FormData();
    formData.append("name", this.state.topicInputActivityEdit);
    formData.append("detail", this.state.textAreaInputActivityEdit);
    formData.append(
      "status",
      values.status ? values.status : this.state.radioStatusValueEdit,
    );
    formData.append("start_date", moment(this.state.startDate).unix());
    formData.append("end_date", moment(this.state.endDate).unix());
    formData.append("image", this.state.imageFile);

    Swal.fire({
      title: "คุณต้องการแก้ไขกิจกรรมออนไลน์ใช่หรือไม่",
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#0c7973",
      confirmButtonText: "ยืนยัน",
      cancelButtonText: "ยกเลิก",
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          title: "ระบบกำลังทำงาน",
          allowEscapeKey: false,
          allowOutsideClick: false,
          showConfirmButton: false,
          onOpen: () => {
            Swal.showLoading();
          },
        });
        eventsApi
          .eventOnlineActivittyUpdateById(id, formData)
          .then((resp) => {
            Swal.close();
            Swal.fire({
              icon: "success",
              title: `${resp.message}`,
              timer: 1500,
              showConfirmButton: false,
            }).then(() => {
              that.history.push("/campaign");
              Swal.close();
            });
          })
          .catch((error) => {
            Swal.close();
            Swal.fire({
              icon: "error",
              title: `${error.response.data.message}`,
              timer: 1500,
              showConfirmButton: false,
            });
          });
      }
    });
  };

  randomCode = async () => {
    await this.setState({
      nameCode: "",
    });
    Swal.fire({
      title: "กำลังสร้างโค้ด",
      allowEscapeKey: false,
      allowOutsideClick: false,
      showConfirmButton: false,
      onOpen: () => {
        Swal.showLoading();
      },
    });
    await eventsApi.eventsOnlineActivityRandomCode().then((res) => {
      this.setState({
        nameCode: res.data,
      });
      Swal.close();
    });
  };

  onChangeNameCode = (e) => {
    const { value } = e.target;
    const valueToUpperCase = value.toUpperCase();
    if (valueToUpperCase.match(/^[A-Z0-9]{0,40}$/)) {
      if (valueToUpperCase !== "") {
        this.setState({
          nameCode: valueToUpperCase,
        });
      } else {
        this.setState({
          nameCode: "",
        });
      }
    }
  };

  //   onChangeType = (e) => {
  //     this.setState({
  //       typeCode: e.target.value,
  //     });
  //   };

  disabledDate = (current) =>
    current && current < moment().add(-1, "days").endOf("day");

  onChangeText = (text) => {
    this.setState({ textAreaInputActivityEdit: text });
  };

  uploadFiles = (uploadFileObj) => {
    const formData = new FormData();
    const that = this;
    formData.append("image", uploadFileObj);
    httpClient
      .post("/news/content/image", formData)
      .then((response) => {
        if (response.data) {
          const range = that.reactQuillRef.getEditorSelection();
          setTimeout(() => {
            that.reactQuillRef
              .getEditor()
              .insertEmbed(range.index, "image", response.data.url);
          }, 2000);
        }
      })
      .catch((error) => {
        throw error;
      });
  };

  imageHandler = () => {
    const input = document.createElement("input");

    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();

    input.onchange = async () => {
      const file = input.files[0];
      this.uploadFiles(file, this.reactQuillRef);
    };
  };

  render() {
    moment.locale("th");

    const { loading, radioStatusValueEdit, imageUrl, nameCode, check_token } =
      this.state;
    const uploadButton = (
      <div>
        {loading ? <LoadingOutlined /> : <PlusOutlined />}
        <div style={{ marginTop: 8 }}>Upload</div>
      </div>
    );
    return (
      <>
        {check_token === true && (
          <Layout
            title="Edit campaign"
            breadcrumbNav={[
              {
                path: "dashboard",
                breadcrumbName: "Dashboard",
              },
              {
                path: "campaign",
                breadcrumbName: "Campaign",
              },
              {
                path: "edit",
                breadcrumbName: "Edit campaign",
              },
            ]}
          >
            <Spin spinning={loading} tip="Loading...">
              {loading === false && (
                <Form layout="vertical" onFinish={this.onFinish}>
                  <Row gutter={[16, 16]}>
                    <Col md={16}>
                      <Card>
                        <Form.Item
                          label="Title"
                          name="name"
                          rules={[
                            {
                              required: true,
                              message: "กรุณากรอกข้อมูล title!",
                            },
                          ]}
                          initialValue={this.state.topicInputActivityEdit}
                        >
                          <Input
                            onChange={(e) =>
                              this.handleChangeInput({
                                topicInputActivityEdit: e.target.value,
                              })
                            }
                          />
                        </Form.Item>
                        <QuillStyle>
                          <Form.Item
                            initialValue={this.state.textAreaInputActivityEdit}
                            name="detail"
                            label="Detail"
                          >
                            <ReactQuill
                              ref={(el) => {
                                this.reactQuillRef = el;
                              }}
                              theme="snow"
                              onChange={this.onChangeText}
                              modules={{
                                toolbar: {
                                  container: [
                                    [{ header: [3, 4, false] }],
                                    ["bold", "italic", "underline"],
                                    [
                                      {
                                        color: [
                                          "#000000",
                                          "#e60000",
                                          "#ff9900",
                                          "#ffff00",
                                          "#008a00",
                                          "#0066cc",
                                          "#9933ff",
                                          "#ffffff",
                                          "#facccc",
                                          "#ffebcc",
                                          "#ffffcc",
                                          "#cce8cc",
                                          "#cce0f5",
                                          "#ebd6ff",
                                          "#bbbbbb",
                                          "#f06666",
                                          "#ffc266",
                                          "#ffff66",
                                          "#66b966",
                                          "#66a3e0",
                                          "#c285ff",
                                          "#888888",
                                          "#a10000",
                                          "#b26b00",
                                          "#b2b200",
                                          "#006100",
                                          "#0047b2",
                                          "#6b24b2",
                                          "#444444",
                                          "#5c0000",
                                          "#663d00",
                                          "#666600",
                                          "#003700",
                                          "#002966",
                                          "#3d1466",
                                        ],
                                      },
                                    ],
                                    [{ list: "ordered" }, { list: "bullet" }],
                                    ["link", "image", "video"],
                                    ["clean"],
                                  ],
                                  handlers: {
                                    image: this.imageHandler,
                                  },
                                },
                                clipboard: {
                                  matchVisual: false,
                                },
                              }}
                            />
                          </Form.Item>
                        </QuillStyle>
                      </Card>
                      <Card className="mt-4">
                        <Form.Item
                          help="ระบุได้เฉพาะ A-Z และตัวเลข 0-9 ไม่เกิน 40 ตัว"
                          label="Code"
                          name="code"
                          initialValue={this.state.nameCodeEdit}
                        >
                          <Search
                            allowClear
                            disabled
                            value={nameCode}
                            enterButton="สุ่มตัวอักษร"
                            onChange={this.onChange}
                            onSearch={this.randomCode}
                          />
                        </Form.Item>
                        <Form.Item
                          label="สิทธิ์ในการแลก"
                          name="amount"
                          help="ขั้นต่ำคือ 1"
                          rules={[
                            {
                              required: true,
                              message: "กรุณากรอกข้อมูล สิทธิ์ในการแลกต่อคน",
                            },
                          ]}
                          initialValue={this.state.quantityExchangeEdit}
                        >
                          <Input
                            type="number"
                            disabled
                            onChange={(e) =>
                              this.handleChangeInput({
                                valueVoucher: e.target.value,
                              })
                            }
                            value={1}
                            onKeyDown={(evt) =>
                              evt.key === "e" ||
                              evt.key === "E" ||
                              evt.key === "."
                                ? evt.preventDefault()
                                : {}
                            }
                            min={1}
                          />
                        </Form.Item>
                      </Card>
                    </Col>
                    <Col md={8}>
                      <Card>
                        <Form.Item className="my-3">
                          <Button type="primary" htmlType="submit">
                            Save
                          </Button>
                          <Button
                            className="mx-4"
                            onClick={() => this.props.history.goBack()}
                          >
                            Cancel
                          </Button>
                        </Form.Item>
                        <Form.Item
                          label="Display day"
                          name="public"
                          rules={[
                            {
                              required: true,
                              message: "กรุณาเลือก วันในการเริ่มและสิ้นสุด!",
                            },
                          ]}
                          initialValue={[
                            moment(this.state.startDate, "YYYY-MM-DD"),
                            moment(this.state.endDate, "YYYY-MM-DD"),
                          ]}
                        >
                          <RangePicker
                            style={{ width: "100%" }}
                            onChange={this.onChange}
                            format="DD/MM/YYYY"
                            disabledDate={this.disabledDate}
                          />
                        </Form.Item>
                        <Form.Item
                          label="Point ที่ได้"
                          name="points"
                          rules={[
                            {
                              required: true,
                              message: "กรุณากรอกข้อมูล คะแนนที่ได้เพิ่ม!",
                            },
                          ]}
                          initialValue={this.state.quantityAddPointsEdit}
                        >
                          <Input
                            type="number"
                            suffix="Points"
                            onChange={(e) =>
                              this.handleChangeInput({
                                textAreaInputActivity: e.target.value,
                              })
                            }
                            onKeyDown={(evt) =>
                              evt.key === "e" ||
                              evt.key === "E" ||
                              evt.key === "."
                                ? evt.preventDefault()
                                : {}
                            }
                            min={1}
                          />
                        </Form.Item>
                        <Form.Item
                          label="Feature image"
                          name="image"
                          extra={
                            <ul>
                              <li>Max file size 1MB.</li>
                              <li>Image with .jpg, .jpeg and .png</li>
                              <li>Image size 1920*1080</li>
                            </ul>
                          }
                        >
                          {/* <ImgCrop aspect={16 / 9}> */}
                          <Upload
                            accept=".jpg, .jpeg, .png"
                            name="upload-img"
                            listType="picture-card"
                            className="form__action avatar-uploader w-100"
                            showUploadList={false}
                            multiple={false}
                            action={`${process.env.REACT_APP_FRONT_API}test`}
                            beforeUpload={beforeUpload}
                            onChange={this.handleChangePhoto}
                          >
                            {imageUrl ? (
                              <img
                                src={imageUrl}
                                alt="avatar"
                                className="img-fluid"
                              />
                            ) : (
                              uploadButton
                            )}
                          </Upload>
                          {/* </ImgCrop> */}
                        </Form.Item>
                        <Form.Item
                          name="Status"
                          label="Status"
                          initialValue={radioStatusValueEdit === 1 ? 1 : 0}
                          rules={[{ required: true }]}
                        >
                          <Radio.Group
                            onChange={(e) =>
                              this.setState({
                                radioStatusValueEdit: e.target.value,
                              })
                            }
                            value={radioStatusValueEdit}
                          >
                            <Radio value={0}>Suspend</Radio>
                            <Radio value={1}>Active</Radio>
                          </Radio.Group>
                        </Form.Item>
                      </Card>
                    </Col>
                  </Row>
                </Form>
              )}
            </Spin>
          </Layout>
        )}
      </>
    );
  }
}

export default CampaignEdit;
